import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-button',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class Input extends mixins(AbstractField) {
  @Prop({ type: String, default: 'primary' }) readonly variant: string;
  @Prop({ type: String }) readonly text: string;
  @Prop([String]) readonly event: string;

  onClick() {
    this.$root.$emit(this.event);
  }

  // updated () { }

  // destroyed () { }
}
